import { onDocumentReady } from '@cornell-engineering/js/utils';

onDocumentReady(() => {
  console.log('Hello from the Cornell Engineering Department theme scripts!'); // eslint-disable-line
});
